import { API } from '../../utils';
import { IAreaFamilies } from './types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

export const GetAreaById = (id: string) => {
  return API.get(`/${C300}/models/areas/`, id);
};

export const GetFamiliesByArea = (data: IAreaFamilies) => {
  return API.get(`/${C300}/forms/area/families/`, undefined, data);
};

export const GetAreasByHouseId = (id: string) => {
  return API.get(`/${C300}/forms/house_areas/`, id);
};

export const GetAreaCommunications = (id: string) => {
  return API.get(`/${C300}/models/area/${id}/communications/`);
};
